import reducer from './reducer.js';
import view from './view.js';

export {reducer, view};



// WEBPACK FOOTER //
// ./src/entry_app/question_box/index.js